<template>
  <div class="input-area none-month">
    <el-form label-position="rigth" :inline="true" label-width="180px" :model="form">
      <el-form-item :label="$t('label.accept_time')">
        <el-date-picker
          :editable="false"
          type="datetimerange"
          unlink-panels
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['10:00:00', '10:00:00']"
          v-model="form.accept_time"
        />
      </el-form-item>
      <el-form-item :label="$t('label.sent_time')">
        <el-date-picker
          :editable="false"
          type="datetimerange"
          unlink-panels
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['10:00:00', '10:00:00']"
          v-model="form.sent_time"
        />
      </el-form-item>
      <el-form-item :label="$t('label.interview_time')">
        <el-date-picker
          :editable="false"
          type="datetimerange"
          unlink-panels
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['10:00:00', '10:00:00']"
          v-model="form.interview_time"
        />
      </el-form-item>
      <el-form-item :label="$t('label.term')">
        <el-date-picker
          :editable="false"
          type="month"
          class="jm-input220"
          v-model="form.term"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item :label="$t('label.apply_school')">
        <el-input class="jm-input220" v-model="form.school_name" />
      </el-form-item>
      <el-form-item :label="$t('label.student_nickname')">
        <el-input class="jm-input220" v-model="form.nickname" />
      </el-form-item>
      <el-form-item :label="$t('label.consult_name')">
        <el-input class="jm-input220" v-model="form.teacher_name" />
      </el-form-item>
      <el-form-item :label="$t('label.interview_in_progress')">
        <jm-dict-select
          class="jm-input220"
          clearable
          type="dataset"
          dict-type="interview"
          name="schedule"
          v-model="form.schedule"
        />
      </el-form-item>
      <el-form-item :label="$t('label.is_sent')" v-permission="[107]" v-if="!isWaitSending">
        <jm-dict-select
          class="jm-input220"
          clearable
          type="dataset"
          dict-type="interview"
          name="sendToSchool"
          v-model="form.send"
        />
      </el-form-item>
      <el-form-item :label="$t('label.interview_way')">
        <jm-dict-select
          class="jm-input220"
          clearable
          type="dataset"
          dict-type="interview"
          name="interviewWay"
          v-model="form.interview_way"
        />
      </el-form-item>
      <el-form-item :label="$t('label.interview_progress')">
        <jm-dict-select
          class="jm-input220"
          clearable
          type="dataset"
          dict-type="interview"
          name="interviewProgress"
          v-model="form.interview_progress"
        />
      </el-form-item>
      <el-form-item :label="$t('label.interview_id')">
        <el-input class="jm-input220" v-model="form.interview_id" clearable />
      </el-form-item>
      <el-form-item :label="$t('label.interview_result')">
        <jm-dict-select
          class="jm-input220"
          clearable
          type="dataset"
          dict-type="interview"
          name="interviewResult"
          v-model="form.interview_result"
        />
      </el-form-item>
      <el-form-item :label="$t('label.certificate')">
        <jm-dict-select
          class="jm-input220"
          clearable
          type="dataset"
          dict-type="interview"
          name="resultUploaded"
          v-model="form.upload_result"
        />
      </el-form-item>
      <el-form-item label="用户ID：" v-permission="[107]">
        <el-input class="jm-input220" v-model="form.user_id" clearable />
      </el-form-item>
      <!--      <el-form-item :label="$t('label.is_canceled')">-->
      <!--        <jm-dict-select-->
      <!--          class="jm-input220"-->
      <!--          clearable-->
      <!--          type="dataset"-->
      <!--          dict-type="common"-->
      <!--          name="yesNo"-->
      <!--          v-model="form.is_canceled"-->
      <!--        />-->
      <!--      </el-form-item>-->
      <!--      <el-form-item :label="$t('label.language_school')">-->
      <!--        <jm-school-search class="jm-input220" clearable :country-id="83" v-model="form.school" />-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="是否当前：" v-permission="[107]">-->
      <!--        <jm-dict-select-->
      <!--          class="jm-input220"-->
      <!--          clearable-->
      <!--          type="dataset"-->
      <!--          dict-type="common"-->
      <!--          name="yesNo"-->
      <!--          v-model="form.is_current"-->
      <!--        />-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="面试状态：" v-permission="[107,108]">-->
      <!--        <jm-dict-select-->
      <!--          class="jm-input220"-->
      <!--          clearable-->
      <!--          type="dataset"-->
      <!--          dict-type="interview"-->
      <!--          name="interviewStatus"-->
      <!--          v-model="form.interview_status"-->
      <!--        />-->
      <!--      </el-form-item>-->
    </el-form>
    <div class="jm-primary">
      <el-button type="primary" @click="doSearch">{{ $t('form.search') }}</el-button>
      <el-button type="primary" @click="resetForm">{{ $t('form.reset') }}</el-button>
      <el-button v-permission="[107]" v-if="isWaitSending" type="primary" @click="batchSend">批量发送</el-button>
    </div>
  </div>
</template>
<script>
import { jmDictSelect, jmSchoolSearch } from '@/components/tool';
import jmTableList from '@/components/data/tableList.vue';
import { isEmpty } from '@/utils/utils';

export default {
  components: {
    jmDictSelect,
    jmTableList,
    jmSchoolSearch
  },
  props: {
    filterData: {
      type: Object,
      default() {
        return {};
      }
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {},
      pickerOptions: {
        disabledDate(time) {
          return [1, 4, 7, 10].indexOf(time.getMonth() + 1) === -1;
        }
      }
    };
  },
  computed: {
    isWaitSending() {
      return this.$route.name === 'wait_sent';
    }
  },
  methods: {
    doSearch(reset) {
      if (this.$route.name === 'wait_sent') {
        this.form.send = 1;
      }
      this.$emit('update:filter-data', this.form);
      this.$emit('update:refresh', true);
      this.$emit('resetActive', reset === 'reset' ? 1 : 0);
    },
    resetForm() {
      this.form = {};
      if (this.hasQuery()) {
        this.$router.push('/');
      }
      this.doSearch('reset');
    },
    /**
     * 批量发送
     */
    async batchSend() {
      try {
        await this.$confirm('确定要批量发送？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        });
      } catch (e) {
        this.$message('批量发送取消');
        return false;
      }

      await this.$http._post({
        url: '/interview/plan/batchSend',
        data: { searchData: this.form }
      });
      this.$message.success('批量发送成功');
      this.doSearch();
    },
    hasQuery() {
      return !isEmpty(this.$route.query);
    },
  },
  mounted() {
    if (this.hasQuery()) {
      const query = this.$route.query;
      if (query.id) {
        this.form.interview_id = query.id;
      }
      if (query.user_id) {
        this.form.user_id = query.user_id;
      }
      this.doSearch();
    }
  }
};
</script>
